export const convertCamelToSnakeCase = (str: string) => {
	return str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}

export const convertSnakeCaseToCamel = (str: string) => {
	return str.replace(/(_\w)/g, k => k[1].toUpperCase());
}